function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 2.5C14.1417 2.5 17.5 5.85833 17.5 10H20L16.6667 13.3333L13.3333 10H15.8333C15.8333 6.775 13.225 4.16667 10 4.16667C6.775 4.16667 4.16667 6.775 4.16667 10C4.16667 13.225 6.775 15.8333 10 15.8333C11.2583 15.8333 12.425 15.425 13.3833 14.75L14.5667 15.95C13.3 16.9167 11.7167 17.5 10 17.5C5.85833 17.5 2.5 14.1417 2.5 10C2.5 5.85833 5.85833 2.5 10 2.5Z",
  fill: "#7D7A8F"
});
function SvgRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.4/media/restore.e55ec433.svg";
export { SvgRestore as ReactComponent };